import styles from "./MovieCard.module.scss";
import LikeButton from "../../../components/shared/LikeButton";
import SavedIcon from "../../../components/icons/searchIcons/savedIcon";
import { Movie } from "./MoviesList";
import { genresData } from "../../../constants/structure";
import { setCurrentItem } from "../../../store/slices/currentItem.slice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import { useTranslation } from "react-i18next";
import FilmRating from "../../../components/icons/searchIcons/fimRating";
import { movieTitleHandler, posterPathHandler } from "../../../utils/helpers";
import { setLoginModal } from "../../../store/slices/modals.slice";
import { useEffect, useState } from "react";

interface ISimilarContentCardProps {
  isMobile: boolean;
  item: Movie;
  liked: boolean;
  isFav: boolean;
  likeHandler: (e: any, item: any, liked: boolean) => void;
  updateVoteLocal: (id: any, key: string, type: string) => void;
  favouritesHandler: (e: any, item: any, isFav: boolean) => void;
}

const MovieCard = ({
  isMobile,
  item,
  liked,
  likeHandler,
  isFav,
  favouritesHandler,
  updateVoteLocal,
}: ISimilarContentCardProps) => {
  const [localImg, setLocalImg] = useState("");
  const [fav, setFav] = useState(isFav);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setFav(isFav);
  }, [isFav]);
  const title = movieTitleHandler(i18n.language, item);

  useEffect(() => {
    setLocalImg(`${process.env.REACT_APP_IMG_BASE_URL}${posterPathHandler(i18n.language, item)}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  const dirData = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div
      dir={dirData}
      id={item.id.toString()}
      className={styles.cardWrapper}
      onClick={() => {
        dispatch(setCurrentItem(item));
        navigate(`${ROUTES.DETAILS}/${item?.id}`);
      }}
    >
      <div className={styles.imgWrapper}>
        <img
          width={isMobile ? 157 : 119}
          height={isMobile ? 240 : 166}
          className={styles.image}
          src={localImg}
          onError={() => setLocalImg(`${process.env.REACT_APP_IMG_BASE_URL}${posterPathHandler("en", item)}`)}
          alt="#"
        />
      </div>
      <div className={styles.textWrapper}>
        <div
          dir={dirData}
          className={styles.savedIconWrapper}
          onClick={(e: any) => {
            const token = localStorage.getItem("accessToken");
            if (!token) {
              dispatch(setLoginModal(true));
              return;
            }

            favouritesHandler(e, item, isFav);
          }}
        >
          <SavedIcon className={`${isMobile ? styles.savedIcon : styles.savedIconDesctop} `} inFavourites={fav} />
        </div>
        <h4 className={styles.movieTitle}>{title}</h4>
        <div className={styles.infoWrapper}>
          <div className={styles.rowInfoWrapper}>
            <div className={styles.badge}>{item.release_date?.substring(0, 4) || "2022"}</div>
            <p className={styles.country}>USA</p>
          </div>
          <p className={styles.description}>
            {item.genre_ids[0] && (
              <span>{t(`${genresData.find((genre) => genre.id === item.genre_ids[0])?.name}`) || "Action"}</span>
            )}
            {item.genre_ids[1] && (
              <span>{t(`${genresData.find((genre) => genre.id === item.genre_ids[1])?.name}`) || "Action"}</span>
            )}
          </p>

          <div className={styles.cardActionsWrapper}>
            <div className={styles.ratingWrapper}>
              <FilmRating />
              <p className={styles.rating}>{item.imdb_rating?.toFixed(1) || item.vote_average?.toFixed(1)}</p>
            </div>
            <LikeButton
              clickHandler={likeHandler}
              direction="row"
              isMobile={isMobile}
              className={styles.likeButton}
              count={item.vote_count}
              updateFieldLocal={updateVoteLocal}
              liked={liked}
              item={item}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovieCard;
